import script from "./TraningSteps.vue?vue&type=script&setup=true&lang=js"
export * from "./TraningSteps.vue?vue&type=script&setup=true&lang=js"

import "./TraningSteps.vue?vue&type=style&index=0&id=c80df1e0&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c80df1e0"]])

export default __exports__